import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import Constants from '../Constants';
import { get_user_error_message } from '../utils/ErrorMessages';

import { useNavigate } from 'react-router-dom';

import wordmark from '../assets/menu-wordmark.jpg';
import '../App.css';

function SignupView() {
  const plan_json = localStorage.getItem(Constants.SIGNUP_SELECTED_PLAN);
  const checkout_plan = plan_json ? JSON.parse(plan_json) : null;

  // const [email, setEmail] = useState(Constants.TEST_SIGNUP_EMAIL);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [signup_coupon, setSignupCoupon] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handle_send = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if(!email || !password || !confirmPassword) {
      setError('All fields are required.');
      return;
    }

    if(password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      localStorage.setItem(Constants.SIGNUP_USER_EMAIL, email,  { path: "/" });

      var plan_id = null;
      if(plan_json){
        const plan = JSON.parse(plan_json);
        if(plan){
          plan_id = plan.id;
        }
      }

      const url = Constants.SERVER_URL + '/api/auth/register';
      const response = await axios.post(url, {
        email: email,
        password: password,
        signup_coupon: signup_coupon,
        plan_id
        // plan_json
      });

      if(response.status === 200 || response.status === 201) {
        setSuccess(true);
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        // navigate('/plans');
        navigate('/verification_email_sent');
        

      } else {
        setError('Unexpected response from server.');
      }
    } catch (error) {
		const message = get_user_error_message(error, 'Sign up failed. Please try again.');
		setError(message);

		if(message == 'User already exists'){
			setTimeout(()=>{ navigate('/login'); }, 1500);
		}
    }
  };

  const render_form_input = (controlId, label, type, placeholder, value, setter, required=true) => {
    return (
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setter(e.target.value)}
          required={required}
        />
      </Form.Group>
    );
  };

  // <Row>
  //   {render_form_input('signupSignupCoupon', 'Signup Coupon', 'signup_coupon', 'Signup Coupon', signup_coupon, setSignupCoupon, false)}
  // </Row>


  return (
    <Container fluid className="auth-container">
      <Row className="auth-row">
        <Col lg={4} md={6} sm={10} xs={11}>
          <Card className="auth-card">
            <Card.Body className='auth-card-body'>
              <img src={wordmark} className="signin-logo"/>
              <h3 className='auth-title'>Sign Up</h3>

              {checkout_plan ? (
                <div className="signup-checkout-plan">
                  <span className="signup-checkout-plan-label">Selected plan:</span>
                  <span className="signup-checkout-plan-name">{checkout_plan.name}</span>
                  <span className="signup-checkout-plan-price">{'$' + (checkout_plan.price_in_cents / 100).toFixed(2) + ' / ' + checkout_plan.billing_interval}</span>
                </div>
              ) : null}

              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">Signup successful!</Alert>}

              <Form onSubmit={handle_send}>
                <Row className="mx-0">
                  {render_form_input('signupEmail', 'Email address', 'email', 'Enter email', email, setEmail)}
                </Row>
                <Row className="mx-0">
                  {render_form_input('signupPassword', 'Password', 'password', 'Enter password', password, setPassword)}
                </Row>
                <Row className="mx-0">
                  {render_form_input('signupConfirmPassword', 'Confirm Password', 'password', 'Confirm password', confirmPassword, setConfirmPassword)}
                </Row>
                
                <div className="d-grid mt-2 form-button auth-form-button">
                  <Button variant="primary" type="submit">Create Account</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default SignupView;
